import React, { useContext } from "react";
import { Button, Box, Container, Typography } from "@mui/material";

import { AppContext } from "../utils";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";
import { useEffect } from "react";
// import { Web3NetworkSwitch } from "@web3modal/react";

const Navbar = () => {
  const { account, connect, disconnect } = useContext(AppContext);

  // useEffect(() => {
  //   connect();
  // }, []);
  useEffect(() => {
    (async () => {
      if (localStorage.getItem("WEB3_CONNECT_CACHED_PROVIDER")) await connect();
    })();
  }, []);

  return (
    <Container>
      {/* <Web3NetworkSwitch /> */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        color="white"
        paddingBottom="2rem"
      >
        <Box display="flex" gap={1} alignItems="center">
          <img src={logo} alt="abc" />
          <NavLink to="/" style={{ textDecoration: "none", color: "white" }}>
            <Box sx={{ fontWeight: "600", fontSize: "22px", color: "white" }}>
              Logo
            </Box>
          </NavLink>
        </Box>

        <Box mb={1} display="flex" gap={2} alignItems="center">
          <Typography
            variant="h6"
            sx={{
              fontSize: "15px !important",
              marginRight: "1.5rem",
              cursor: "pointer",
              color: "white",
              fontWeight: "700",
              display: { md: "block", xs: "none" },
            }}
          >
            <NavLink
              to="/presale"
              style={{ textDecoration: "none", color: "white" }}
            >
              PreSale
            </NavLink>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              display: { md: "block", xs: "none" },
              fontSize: "15px !important",
              marginRight: "1.5rem",
              cursor: "pointer",
              color: "white",
              fontWeight: "700",
            }}
          >
            <NavLink
              to="/staking"
              style={{ textDecoration: "none", color: "white" }}
            >
              Staking
            </NavLink>
          </Typography>
          {account ? (
            <Button
              sx={{
                my: 2,
                color: "white",
                display: "block",
                padding: { md: "0.5rem 1.5rem", xs: "0.5rem" },
                background:
                  "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
              }}
              onClick={() => disconnect()}
              style={{ zIndex: 1 }}
            >
              {account.slice(0, 4) + "..." + account.slice(-4)}
            </Button>
          ) : (
            <Button
              sx={{
                my: 2,
                color: "white",
                display: "block",
                padding: { md: "0.5rem 1.5rem", xs: "0.5rem" },
                background:
                  "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
              }}
              onClick={() => connect()}
            >
              Connect wallet
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default Navbar;
